'use client';

import { CaretDownFilled, cn } from '@wk/wk-uni-lib';
import { useState } from 'react';

import { useLanguage } from '@/hooks/use-language';
import { useTraceCommonParams } from '@/hooks/use-trace-common-params';

export default function LanguageSelector() {
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const { traceWithCommonParams } = useTraceCommonParams();
  const { currentLanguage, getLanguageDisplayName, switchLanguage } =
    useLanguage();

  const handleLanguageSwitch = (newLang: 'en' | 'zh') => {
    traceWithCommonParams({
      _event: 'C_TopNav_Language',
      optionValue: newLang,
    });
    switchLanguage(newLang);
    setIsLanguageOpen(false);
  };

  return (
    <div
      onMouseEnter={() => setIsLanguageOpen(true)}
      onMouseLeave={() => setIsLanguageOpen(false)}
      className="flex h-full items-center">
      <div className="relative">
        <button className="flex items-center text-sm text-text-primary transition-colors duration-200">
          <span>{getLanguageDisplayName(currentLanguage)}</span>
          <CaretDownFilled className="ml-1 h-4 w-4" />
        </button>
        <div
          className={cn(
            'absolute left-1/2 z-tooltip mt-2 w-[140px] -translate-x-1/2 rounded-lg border-[1px] border-border-normal bg-white p-4 shadow-tooltip transition-all duration-200 ease-in-out',
            isLanguageOpen
              ? 'visible translate-y-0 scale-100 opacity-100'
              : 'pointer-events-none invisible -translate-y-2 scale-95 opacity-0',
          )}>
          <button
            onClick={() => handleLanguageSwitch('zh')}
            className={cn(
              'block w-full rounded-md p-3 text-left font-medium hover:bg-bg-card_gray_light',
              currentLanguage === 'zh' && 'text-brand-red-100',
            )}>
            中文
          </button>
          <button
            onClick={() => handleLanguageSwitch('en')}
            className={cn(
              'block w-full rounded-md p-3 text-left font-medium hover:bg-bg-card_gray_light',
              currentLanguage === 'en' && 'text-brand-red-100',
            )}>
            English
          </button>
        </div>
      </div>
    </div>
  );
}
